import { ProductType } from 'constants/product'

/**
 * The service the user picked on the embed value-proposition overlay (ISSUE-2017). Each overlay
 * card deep-links into the wizard pre-filtered for its service category.
 */
export enum EmbedCategoryHint {
  PHOTOS = 'PHOTOS',
  DRONE = 'DRONE',
  VIDEOS = 'VIDEOS',
  VIRTUAL_TOURS = 'VIRTUAL_TOURS',
  FLOOR_PLANS = 'FLOOR_PLANS',
  MEASUREMENTS = 'MEASUREMENTS',
}

/**
 * ProductType is the Product step's native filter granularity (the left-hand checkboxes drive the
 * listing through `selectedFilterTypes`), so the hint maps onto it. Drone packs are
 * `kind=DRONE_PHOTO` under type PHOTO and Aufmaß is `kind=MEASUREMENT_ON_SITE` under type
 * FLOOR_PLAN — kind-level filtering does not exist in the step, so those hints pre-filter their
 * parent type.
 */
const hintProductTypes: Record<EmbedCategoryHint, ProductType[]> = {
  [EmbedCategoryHint.PHOTOS]: [ProductType.PHOTO],
  [EmbedCategoryHint.DRONE]: [ProductType.PHOTO],
  [EmbedCategoryHint.VIDEOS]: [ProductType.VIDEO],
  [EmbedCategoryHint.VIRTUAL_TOURS]: [ProductType.VIRTUAL_VISIT],
  [EmbedCategoryHint.FLOOR_PLANS]: [ProductType.FLOOR_PLAN],
  [EmbedCategoryHint.MEASUREMENTS]: [ProductType.FLOOR_PLAN],
}

/**
 * Resolves the product-type filters to pre-select for an overlay hint, intersected with the types
 * the loaded catalogue actually offers: an unavailable hinted type degrades to the normal
 * unfiltered step instead of an empty product list.
 */
export const productTypesForHint = (hint: EmbedCategoryHint, availableTypes: ProductType[]): ProductType[] => {
  const available = new Set(availableTypes)
  return hintProductTypes[hint].filter((type) => available.has(type))
}
